import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@dhl-ui/components'
import { useSpinnerDelay } from '@dhl/use-spinner-delay'
import { useCachedBasketSummary } from '../hooks/useCachedBasketSummary.js'
import { CartIcon } from './CartIcon.js'

type Props = {
  onClick?: () => void
}

export const CurrentCartIcon: FC<Props> = ({ onClick }) => {
  const { data, isLoading } = useCachedBasketSummary()
  const isDelayedLoading = useSpinnerDelay(isLoading)

  const { t } = useTranslation()

  return (
    <IconButton aria-label={t('c2c.common.buttons.goToBasket')} size="small" onClick={onClick} variant="ghost">
      <CartIcon isLoading={isDelayedLoading} numberOfItems={data?.numberOfItems} />
    </IconButton>
  )
}
